<div _ngcontent-dsl-c111="" class="WordSection1">
    <div _ngcontent-dsl-c111="">
        <div _ngcontent-dsl-c111="">
            <table _ngcontent-dsl-c111="" cellspacing="0" cellpadding="0" style="border-collapse: collapse;">
                <tr _ngcontent-dsl-c111="" style="height: .5in;">
                    <td _ngcontent-dsl-c111="" width="110" valign="top"
                        style="width: 1.15in; padding: 0in 5.4pt 0in 5.4pt; height: .5in;">
                        <p _ngcontent-dsl-c111="" style="margin: 0;">
                            <b _ngcontent-dsl-c111="">
                                <span _ngcontent-dsl-c111="" style="color: #4472C4;"><img _ngcontent-dsl-c111=""
                                        width="96" height="96" id="Picture_x0020_1"
                                        [src]="['assets/HCUS-logo-300x300px.png']"
                                        alt="Harris County Universal Services logo"
                                        style="width: 1.0in; height: 1.0in;">
                                </span>
                                <span _ngcontent-dsl-c111="" style="color: #4472C4;">
                                    <p _ngcontent-dsl-c111=""></p>
                                </span></b>
                        </p>
                    </td>
                    <td _ngcontent-dsl-c111="" width="207" valign="middle"
                        style="width: 155.45pt; padding: 0in 5.4pt 0in 5.4pt; height: .5in;">
                        <p _ngcontent-dsl-c111="" contenteditable="true" style="margin: 0;">Universal Services </p>
                        <p _ngcontent-dsl-c111="" style="margin: 0;" contenteditable="true">713-274-4444</p>
                    </td>
                </tr>
            </table>
            <p _ngcontent-dsl-c111="">&nbsp;</p>
        </div>
    </div>
</div>

